import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { eaterySchema } from 'schemas';
import { selectors as entitySelectors } from 'schemas/duck';
import { stateKey } from 'utils';
import reducer from './reducers';

const STATE_KEY = stateKey(reducer);

const mapOptions = ({ id, name: label }) => ({ value: id.toString(), label });

const sortLabels = ({ label: l1 }, { label: l2 }) => l1.localeCompare(l2);

const selectAmbienceTags = createSelector(
  entitySelectors.entities,
  ({ tag = {} }) =>
    Object.values(tag).filter(({ tagDimension }) => tagDimension === 'AMBIENCE')
);

const selectAmenities = createSelector(
  entitySelectors.entities,
  ({ amenity = {} }) =>
    Object.values(amenity)
      .filter(({ amenitiesType }) => amenitiesType === 'EATERY')
      .map(mapOptions)
);

const selectCities = createSelector(
  entitySelectors.entities,
  ({ city = {} }) =>
    Object.values(city)
      .map(mapOptions)
      .sort(sortLabels)
);

const selectCuisines = createSelector(
  entitySelectors.entities,
  ({ cuisine = {} }) =>
    Object.values(cuisine)
      .map(mapOptions)
      .sort(sortLabels)
);

const selectDishTags = createSelector(
  entitySelectors.entities,
  ({ tag = {} }) =>
    Object.values(tag)
      .filter(({ tagDimension }) => tagDimension === 'DISH')
      .map(mapOptions)
      .sort(sortLabels)
);

const selectEatery = createSelector(
  (_, props) => props.match.params.slug,
  entitySelectors.entities,
  (slug, entities) => denormalize(slug, eaterySchema, entities)
);

// const selectTips = createSelector(
//   (_, props) =>
//     get(entitySelectors.entities, `eatery[${props.match.params.slug}].id`),
//   entitySelectors.entities,
//   (eateryId, entities) => {
//     const tips = Object.keys(entities.tip).filter(
//       id =>
//         entities.tip[id].resourceType === 'EATERY' &&
//         entities.tip[id].resourceId === eateryId
//     );

//     return denormalize(tips, [tipSchema], entities);
//   }
// );

const selectEditedSlug = state => state[STATE_KEY].editedSlug;

const selectIsSaving = state => state[STATE_KEY].isSaving;

export default {
  selectAmbienceTags,
  selectAmenities,
  selectCities,
  selectCuisines,
  selectDishTags,
  selectEatery,
  // selectTips,
  selectEditedSlug,
  selectIsSaving,
};
